import Slide from "../../../../../../components/Slide";
import QList from "../../../../../../components/QList";
import QHeader from "../../../../../../components/QHeader";

import BackgroundImage from "../../../../../../assets/_Chapters/_Images/background/BeratungPlanungMontage/1.webp";
import { Grid } from "@material-ui/core";

export default function Planung() {
  return (
    <Slide
      background={{
        image: BackgroundImage,
        width: "50dvw",
        align: "right",
        position: "center",
      }}
    >
      <Grid container spacing={5} alignItems="center">
        <Grid item xs={6}>
          <QHeader title="Planung – mit uns ist alles möglich" />
          <QList
            items={[
              "Aufmaß vor Ort",
              "Entwicklung kundenspezifischer Lösungen",
              "Fotorealistische 3D-Visualisierung",
            ]}
          />
        </Grid>
        <Grid item xs={6}></Grid>
      </Grid>
    </Slide>
  );
}
